import { withInstall } from '@lit-element/utils'

import Comment from './src/comment.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtComment: SFCWithInstall<typeof Comment> = withInstall(Comment)
export default LtComment
